import { Link } from "react-router-dom";
import { revitHeroImage } from "@/mocks/serviceRevitData";

export default function RevitHero() {
  return (
    <section className="relative min-h-[460px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={revitHeroImage}
          alt="Modelo BIM 3D de un edificio con ductos HVAC, equipos de aire acondicionado, tuberías y sistemas de ventilación"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay-gradient absolute inset-0" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-background-400 mb-6">
            <Link
              to="/"
              className="hover:text-background-200 transition-colors whitespace-nowrap"
            >
              Inicio
            </Link>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-500" />
            <span className="text-background-200 whitespace-nowrap">Servicios</span>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-500" />
            <span className="text-background-200 whitespace-nowrap">Diseño BIM en Revit</span>
          </nav>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            DISEÑO E INGENIERÍA BIM EN REVIT
          </h1>

          <p className="text-base md:text-lg text-background-200 font-semibold mb-4 leading-relaxed">
            Modelamos tus sistemas antes de construirlos
          </p>

          <p className="text-background-300 text-sm md:text-base max-w-2xl leading-relaxed mb-8">
            Desarrollamos modelos digitales y diseños técnicos de sistemas HVAC, climatización,
            ventilación y refrigeración utilizando herramientas de modelado BIM para mejorar la
            planificación, coordinación y ejecución de los proyectos.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="https://wa.link/b002hg"
              className="px-7 py-3.5 rounded-lg bg-[#0087a4] text-white font-semibold text-sm md:text-base hover:bg-[#006f86] transition-colors shadow-lg shadow-[#0087a4]/20 text-center whitespace-nowrap"
            >
              <i className="ri-file-list-3-line mr-2" />
              SOLICITAR ASESORÍA
            </a>
            <a
              href="https://wa.link/0adpkz"
              className="px-7 py-3.5 rounded-lg bg-white/10 text-background-50 font-semibold text-sm md:text-base border border-white/20 hover:bg-white/20 transition-colors text-center whitespace-nowrap"
            >
              <i className="ri-arrow-down-line mr-2" />
              VER SERVICIOS
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}